import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../utilities/constants";
import PaginatedDropdown, { mapOptions } from "../../components/ui/PaginatedDropDown";


const TableFilter = ({ onMerchantTypeChange, type }) => {
  const [selectedMerchantType, setSelectedMerchantType] = useState(type || null);

   useEffect(() => {
    if (type) {
      const option = {
        value: type.id,
        label: type.name,
        obj: type,
      };
      setSelectedMerchantType(option);
      onMerchantTypeChange?.(type.id);
    }
  }, [type]);



  const labelMerchantTypeFunc = (o) =>`${o.name}`;
  return (
    <div className="flex flex-col md:flex-row md:items-end gap-3">
      <div className="flex flex-col w-full md:w-64">
        <div className=" px-2">
          <PaginatedDropdown
            searchkey="search"
            datakey=""
            selectedValue={selectedMerchantType}
            url={`${API_BASE_URL}/api/1.0.0/partner?`}
            mapOptions={(records) =>
              mapOptions(records, "id", labelMerchantTypeFunc)
            }
            placeHolder="Select Merchant"
            onChange={(v) => {
              console.log("VVVV",v);
              // handleQueryParamChange("id", v?.value);
              setSelectedMerchantType(v);
              onMerchantTypeChange?.(v?.value);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TableFilter;



